// extracted by mini-css-extract-plugin
module.exports = {"container":"tag-list_container__1nKpW"};